import * as getters from './getters';
import * as actions from './actions';
import * as mutations from './mutations';
import { state } from './state';
import timer from '@/core/shared/vuex-modules/timer';
import interop from './modules/interop';

export default {
  strict: true,
  state,
  getters,
  actions,
  mutations,
  modules: {
    timer,
    interop,
  },
};
